import { render, staticRenderFns } from "./carrier.vue?vue&type=template&id=45fc1783&scoped=true&"
import script from "./carrier.vue?vue&type=script&lang=js&"
export * from "./carrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc1783",
  null
  
)

export default component.exports